import { useTranslation } from "react-i18next";

import { Facebook, Instagram, LinkedIn, Twitter } from "@/assets/icons/icons";
import { FocusRing } from "@/components/Layout/BaseLayouts/Footer/FocusRing";
import { KEYBOARD_TAB_INDEX } from "@/utils/keyboardTabIndex";

const socialLinks = [
  {
    icon: Facebook,
    label: "Facebook",
    url: "https://www.facebook.com/digitalrepublicconnect",
  },
  { icon: Twitter, label: "Twitter", url: "https://x.com/digitrep" },
  {
    icon: Instagram,
    label: "Instagram",
    url: "https://www.instagram.com/digitalrepublic.ch",
  },
  {
    icon: LinkedIn,
    label: "LinkedIn",
    url: "https://www.linkedin.com/company/digital-republic-ch/",
  },
];

export const SocialButtonMenu = () => {
  const { t } = useTranslation();

  return (
    <nav
      className="flex flex-row gap-2"
      aria-label={t("Footer.socialLinksNavAriaLabel")}
    >
      {socialLinks.map(({ icon: Icon, label, url }) => (
        <a
          key={label}
          className="group relative rounded-md p-1 hover:bg-surface-secondary-inverse focus:outline-none active:bg-surface-secondary-inverse"
          href={url}
          tabIndex={KEYBOARD_TAB_INDEX}
          aria-label={label}
          target="_blank"
          rel="noreferrer"
        >
          <Icon className="size-6" />
          <FocusRing inverted />
        </a>
      ))}
    </nav>
  );
};
